<template>
  <div>
    <b-alert v-if="!mesa_diretora.mandato_id" show variant="warning">
      Selecione um mandato antes de adicionar cargos à mesa diretora
    </b-alert>

    <div v-else>
      <b-card v-for="grupo in grupos" :key="grupo.id" class="mb-3">
        <template #header>
          <div class="d-flex justify-content-between">
            <div v-if="grupo.id === null">{{ grupo.label }}</div>
            <div v-else style="width: 100%">
              <b-form-input
                v-model="grupo.label"
                class="input-header"
                @blur="changeGrupo(grupo)"
              />
            </div>

            <b-button
              v-if="grupo.id === null"
              v-b-tooltip.hover
              class="add"
              size="sm"
              variant="primary"
              @click="addCargo('Novo Grupo')"
            >
              <b-icon icon="plus" aria-hidden="true" /> Novo Grupo
            </b-button>

            <b-button
              v-else
              v-b-tooltip.hover
              class="add"
              size="sm"
              variant="outline-danger"
              @click="deleteGrupo(grupo.id)"
            >
              <font-awesome-icon icon="trash-alt" />
            </b-button>
          </div>
        </template>

        <b-row
          v-for="(cargo, key) in getCargosGrupo(grupo.id)"
          class="mb-2"
          :key="key"
        >
          <b-col>
            <b-form-input
              v-model="cargo.cargo_outro"
              :placeholder="cargo.cargo"
              :disabled="is_cargo_fixo(cargo.cargo)"
            />
          </b-col>
          <b-col class="d-flex justify-content-between">
            <select-conselheiro
              v-model="cargo.conselheiro_id"
              :conselhoId="conselhoId"
              :mandato_id="mesa_diretora.mandato_id"
              mandato_tipo="mesa-diretora"
              :mandato_ini="mesa_diretora.mandato.gestao_ini"
              :mandato_fim="mesa_diretora.mandato.gestao_fim"
            />

            <b-button
              @click="deleteCargo(cargo)"
              variant="outline-danger"
              v-if="!is_cargo_fixo(cargo.cargo)"
            >
              <font-awesome-icon icon="trash-alt" />
            </b-button>
          </b-col>
        </b-row>
        <div class="d-flex">
          <b-button
            v-b-tooltip.hover
            title="Adicionar cargo"
            class="add mt-2"
            size="sm"
            variant="primary"
            @click="addCargo(grupo.id)"
          >
            <b-icon icon="plus" aria-hidden="true"></b-icon>
          </b-button>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { mapGetters, mapState } from "vuex";
import SelectConselheiro from "@/modules/conselheiros/Components/SelectConselheiro.vue";
import _ from "lodash";

export default {
  components: { SelectConselheiro },
  mixins: [validationMixin],
  data: () => ({
    cargos: [],
    grupos: [
      {
        id: null,
        label: "Cargos da Mesa Diretora",
      },
    ],
  }),
  validations: {
    mesa_diretora: {},
  },
  computed: {
    ...mapState("mesas_diretoras", ["mesa_diretora"]),
    ...mapGetters("mesas_diretoras", ["cargos_default", "cargos_fixos"]),
    conselhoId() {
      const hasConselhoId = "conselho_id" in (this.mesa_diretora || {});
      return hasConselhoId ? this.mesa_diretora.conselho_id : -1;
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.mesa_diretora[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.mesa_diretora.$touch();
      return !this.$v.mesa_diretora.$anyError;
    },
    is_cargo_fixo(cargo) {
      return this.cargos_fixos.indexOf(cargo) >= 0;
    },
    getCargosGrupo(id) {
      return this.cargos.filter((v) => v.grupo == id);
    },
    addCargo(grupo = null) {
      this.cargos.push({
        conselheiro_id: null,
        cargo: "outros",
        cargo_outro: "",
        grupo: grupo,
      });
    },
    deleteCargo(cargo) {
      const index = this.cargos.findIndex((v) => {
        return (
          v.conselheiro_id == cargo.conselheiro_id &&
          v.grupo == cargo.grupo &&
          v.cargo == cargo.cargo
        );
      });

      if (this.cargos[index].cargo == "outros") {
        this.cargos.splice(index, 1);
      }
    },
    changeGrupo(grupo) {
      if (!grupo.label) {
        grupo.label = grupo.id;
      }

      this.cargos.forEach((cargo) => {
        if (cargo.grupo == grupo.id) {
          cargo.grupo = grupo.label;
        }
      });
    },
    deleteGrupo(grupo) {
      const cargos = this.getCargosGrupo(grupo);
      cargos.forEach((cargo) => this.deleteCargo(cargo));
    },
    initCargos() {
      let cargos = [];
      cargos.push(...this.cargos_default);
      this.cargos = cargos;
    },
  },
  watch: {
    cargos: {
      deep: true,
      handler: function (cargos) {
        const grupos = cargos
          .map((v) => {
            return v.grupo;
          })
          .filter((value, index, self) => self.indexOf(value) === index);

        this.grupos = grupos.map((grupo) => {
          return {
            id: grupo,
            label: grupo ? grupo : "Cargos da Mesa Diretora",
          };
        });

        this.mesa_diretora.mesa_diretora_cargos = cargos;
      },
    },
    "mesa_diretora.mesa_diretora_cargos": {
      deep: true,
      handler: function (value, new_value) {
        let diff = _.difference(value, new_value);

        if (diff.length) {
          let cargos = [];
          cargos.push(...this.cargos_default);

          this.mesa_diretora.mesa_diretora_cargos.forEach((cargo, key) => {
            if (this.is_cargo_fixo(cargo.cargo)) {
              let index = this.cargos_fixos.indexOf(cargo.cargo);
              cargos[index] = cargo;
            } else {
              cargos.push(cargo);
            }
          });

          this.cargos = cargos;
        }
      },
    },
  },
  created() {
    this.initCargos();
  },
};
</script>

<style lang="scss">
.input-header {
  width: 100%;
  background: transparent;
  border: none;
  margin: 0;
  padding: 0;
  font-size: inherit;
  color: inherit;
  height: auto;

  &:focus {
    background: transparent;
  }
}
</style>
